import { useMutation } from 'react-query'
import { putAPI } from 'framework/api/http'

interface UpdatePartnerInterface {
  partnerId?: string
  partnerCode?: string
  partnerName?: string
  contactPerson?: string
  contactEmail?: string
  supportEmail?: string
  phoneNo?: string
  streetAddress?: string
  suburb?: string
  state?: any
  country?: any
  postalCode?: string
  status?: boolean
  partnerSLAs?: any[]
}

export const useUpdatePartner = () => {
  const mutate = useMutation(
    ({
      partnerId,
      partnerCode,
      partnerName,
      contactPerson,
      contactEmail,
      supportEmail,
      phoneNo,
      streetAddress,
      suburb,
      state,
      country,
      postalCode,
      status,
      partnerSLAs,
    }: UpdatePartnerInterface) => {
      return putAPI('/partner', {
        id: partnerId,
        code: partnerCode,
        name: partnerName,
        contactName: contactPerson,
        contactEmail: contactEmail,
        supportEmail: supportEmail,
        contactPhone: phoneNo,
        address: {
          lineOne: streetAddress,
          lineTwo: '',
          city: '',
          suburb: suburb,
          state: state?.label,
          stateCode: state?.value,
          country: country.label,
          countryCode: country.value,
          postCode: postalCode,
        },
        isActive: status,
        partnerSLAs: (partnerSLAs ?? []).map((sla) => {
          const base = {
            partnerCode: sla.partnerCode,
            orderType: sla.orderType,
            kpiType: sla.type,
            category: 'salesOrderOutbound',
          }

          if (sla.type === 'DOT_Hours') {
            return {
              ...base,
              hours: sla.hours,
            }
          }

          if (sla.type === 'DOT_Cutoff') {
            return {
              ...base,
              CutOffTimeStart: sla.startTime,
              CutOffTimeEnd: sla.endTime,
              DispatchInDays: sla.dispatchDays,
            }
          }

          return base // dispatch
        }),
      })
    },
  )

  return mutate
}

export default useUpdatePartner
